<template>
    <div class="col-md-4 grid-margin stretch-card">
      <div class="card activeCard">
          <div class="card-body">
            <div class="d-flex align-items-start justify-content-between pointer">
              <h6 class="card-title flex-grow lower-line text-truncate">{{ $t('MdCensusByProgram.CensusByProgram') }}</h6>  
              <div class="text-center" v-if="VisibleSpinner" style="margin-top:-2px;">
                <b-spinner variant="primary" small label="Text Centered"></b-spinner>
              </div>                        
            </div>                 
            <div class="text-muted p-fixed cutescroll">
                <p v-if="List.length === 0">{{ $t('MdAdmissionByDay.NoKnown') }}</p>
                <ul class="censusProgram">	
                    <li v-for="(h, index) in List" :key="`h.id-${index}`" class="mb-2">
                      <span>{{ h.activeAdmissions }}</span> {{h.program}}
                    <!-- {{h.program}}<br>
                     <div class="progress-container">
                        <div class="progress-fill" :style="{ width: h.percent + '%' }"></div>
                        <div class="progress-text">
                          <span class="text-inside" :style="{ clipPath: 'inset(0 ' + (100 - h.percent) + '% 0 0)' }">
                            {{ h.activeAdmissions }} of {{totalAdmissions}} <span class="divPercent">(</span>{{h.percent}}%<span class="divPercent">)</span>
                          </span>
                          <span class="text-outside" :style="{ clipPath: 'inset(0 0 0 ' + h.percent + '%)' }">
                           {{ h.activeAdmissions }} of {{totalAdmissions}} <span class="divPercent">(</span>{{h.percent}}%<span class="divPercent">)</span>
                          </span>
                        </div>
                      </div> -->
                    </li>											
                </ul>
            </div>
          </div>
      </div>
    </div>
</template>

<script>
import DBFunctions from '@/common/DBFunctions.js'
import ClinicalService from '@/services/clinical.service'
// import Utils from '@/common/utils.js'
export default {
  props: {
   PatientCode: String,
 },
  mixins: [DBFunctions],
  data() {
    return {
      List:[],  
      VisibleSpinner:false,
      totalAdmissions:0,
      // Sample data structure for testing
      // In real implementation, this data will come from the API
      programs : [
        { program: "Program A", activeAdmissions: 5 },
        { program: "Program B", activeAdmissions: 45 },
        { program: "Program C", activeAdmissions: 23 },
        { program: "Program D", activeAdmissions: 7 },
        { program: "Program E", activeAdmissions: 10 }
      ]    
    }
  },
   
methods:{

  async getCensusByProgram(){     
    var param = {		
      IsAdmissionsByDay: true,   
		};
    this.VisibleSpinner = true;
      await ClinicalService.getCensusByProgram(param)
        .then((response) => {
              if(response.status == '200' && response.data ){
                const data = response.data;
                this.getPercent( data );   
                this.VisibleSpinner = false;               
              }    
              this.VisibleSpinner = false;                    
        })
        .catch((error) => {
          this.VisibleSpinner = false;         
            if (error.response) {
                this.showMessage(this.$tc('Msg.Error'),error,"error");
            }
        });  
    },
    getPercent(paramData) {
      // Input validation
      if (!paramData || !Array.isArray(paramData)) {
          console.error('Invalid input: paramData must be an array');
          this.List = [];
          return;
      }

      // Use paramData instead of this.programs for consistency
      const programs = paramData;
      
      // Calculate total
      const total = programs.reduce((sum, p) => sum + (p.activeAdmissions || 0), 0);
      this.totalAdmissions = total;

      // Special case: total zero
      if (total === 0) {
          this.List = programs.map(p => ({
              program: p.program,
              activeAdmissions: p.activeAdmissions || 0,
              percent: 0
          }));
          return;
      }

      // Calculate percentages and prepare data for rounding
      const percentagesData = programs.map((program, index) => {
          const activeAdmissions = program.activeAdmissions || 0;
          const rawPercent = (activeAdmissions / total) * 100;
          
          return {
              index,
              program: program.program,
              activeAdmissions,
              rawPercent,
              floorPercent: Math.floor(rawPercent),
              fractionalPart: rawPercent - Math.floor(rawPercent)
          };
      });

      // Calculate sum of whole parts and remainder
      const totalFloor = percentagesData.reduce((sum, item) => sum + item.floorPercent, 0);
      let remainder = 100 - totalFloor;

      // Sort by descending fractional part to distribute the remainder
      const sortedByFraction = [...percentagesData]
          .sort((a, b) => b.fractionalPart - a.fractionalPart || b.activeAdmissions - a.activeAdmissions);

      // Distribute remaining percentage points
      const finalPercentages = percentagesData.map(item => item.floorPercent);
      
      for (let i = 0; i < remainder; i++) {
          if (i < sortedByFraction.length) {
              finalPercentages[sortedByFraction[i].index]++;
          }
      }

      // Build final result
      this.List = percentagesData.map((item, i) => ({
          program: item.program,
          activeAdmissions: item.activeAdmissions,
          percent: finalPercentages[i]
      }));
    }
  },

  mounted() {
    this.getCensusByProgram();
  }
}

</script>
<style scoped>
.progress-container {
  position: relative;
  width: 120px;
  height: 16px;
  background: #FFF;
  border-radius: 999px;
  border: 1px solid #6ec1e4;
  overflow: hidden;
}

.progress-fill {
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  background: #6ec1e4;
  border-radius: 50%, 0, 0, 50%;
  transition: width 1s ease;
  z-index: 1;
}

.progress-text {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  font-size: 11px;
  font-weight: bold;
  line-height: 15px;
  text-align: left;
  pointer-events: none;
  z-index: 2;
}

.text-inside {
  color: white;
  position: absolute;
  width: 100%;
  height: 100%;
  vertical-align: middle !important;
  padding-left: 10px;
}

.text-outside {
  color: #6ec1e4;
  position: absolute;
  width: 100%;
  height: 100%;
  padding-left: 10px;
}

.divPercent{
  color: #aadef4;
  font-size: 8px;
  vertical-align: top !important;
  padding-inline: 2px;
}

/* simple number for census */
.censusProgram{
  list-style-type: none;
}
.censusProgram li span{
  background-color: #19bee1;
  color: #FFF;
  border-radius: 10px;
  padding: 0 6px;
}
</style>